import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { GlobalVariableService } from "../../../../../common/variables/global-variable";
import { FormGroup, FormBuilder, Validators } from "@angular/forms"
import { TranslateService } from "../../../../../common/variables/translate-service";
import { AddressType } from "../../../../../common/lib/addressType";
import { DocAddressSaveInput, DocAddressSaveOutput } from "../../../../../common/api/DocAddressSave";
import { DocAddressGetAllInput, DocAddressGetAllOutput, DocAddressOutput } from "../../../../../common/api/DocAddressGetAll";
import { GlobalService } from "../../../../../common/services/global.service";
import { InputBase } from 'projects/sen-app/src/app/core/common/api/common/InputBase';
import { DocAddressData } from 'projects/sen-app/src/app/core/common/api/DocAddressGet';
import { DocAddressRemoveInput, DocAddressRemoveOutput } from 'projects/sen-app/src/app/core/common/api/DocAddressRemove';
import * as _ from 'lodash';

@Component({
  selector: 'sen-app-customer-data',
  templateUrl: './customer-data.component.html',
  styleUrls: ['./customer-data.component.scss']
})
export class CustomerDataComponent implements OnInit {
  @Input() type: AddressType;
  @Input() phoneNumber: boolean;
  @Input() data: DocAddressOutput;
  @Output() emitAddress = new EventEmitter<DocAddressData>();

  displayedColumns: string[] = ['company', 'firstName', 'lastName', 'action'];
  coverPhoto: string;
  selectedAdd: DocAddressOutput;
  address: DocAddressData;
  dataSource: DocAddressOutput[];

  public form: FormGroup;
  constructor(public global: GlobalVariableService, private globalService: GlobalService, public formGroup: FormBuilder, public translate: TranslateService) {
    this.form = formGroup.group({
      company: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      street: ['', Validators.required],
      postalCode: ['', Validators.required],
      location: ['', Validators.required],
      countryISO: [this.global.deString.toUpperCase(), Validators.required],
      lat: ['', Validators.required],
      lon: ['', Validators.required],
      full: ['', Validators.required]
    });
    this.form.valueChanges.subscribe(data => {
      this.address = data;
      if (this.form.valid) {
        this.emitAddress.emit(this.address);
      }
    })
  }

  ngOnInit(): void {
    this.getAddresses();
    if (this.phoneNumber) {
      this.form.addControl('new', this.formGroup.group({
        phoneNumber: ['', Validators.pattern(this.global.phoneNumberValidator)]
      }));
    }
    if (this.data) {
      this.setSelectedAddress(this.data);
    }
  }

  setSelectedAddress(row: DocAddressOutput) {
    this.selectedAdd = _.cloneDeep(row);
    this.form.get('company')?.setValue(row.company);
    this.form.get('firstName')?.setValue(row.firstName);
    this.form.get('lastName')?.setValue(row.lastName);
    this.setAddress(row);
    this.form.markAsPristine();
  }

  setAddress(row:any, dirty?:boolean) {
    this.form.get('street')?.setValue(row.street);
    this.form.get('postalCode')?.setValue(row.postalCode);
    this.form.get('location')?.setValue(row.location);
    this.form.get('countryISO')?.setValue(row.countryISO);
    this.form.get('lat')?.setValue(row.lat);
    this.form.get('lon')?.setValue(row.lon);
    if(dirty) {
      this.selectedAdd.street = row.street;
      this.selectedAdd.postalCode = row.postalCode;
      this.selectedAdd.location = row.location;
      this.selectedAdd.countryISO = row.countryISO;
      this.selectedAdd.lat = row.lat ;
      this.selectedAdd.lon = row.lon;
      this.form.markAsDirty();
    }
  }

  getAddresses() {
    const qParam: DocAddressGetAllInput = {
      cmd: this.global.DocAddressGetAll,
      type: this.type
    };
    this.globalService.getData(qParam).subscribe((data: DocAddressGetAllOutput) => {
      try {
        if (data.ok.data) {
          this.dataSource = data.ok.data.addresses;
        }
      } catch {
        if (!data.error.data.length) {
          this.dataSource = [];
        }
      }
    });
  }

  saveAddress() {
    this.form.markAllAsTouched();
    if (this.form.invalid || this.form.pristine) {
      return;
    }
    const qParam: InputBase = {
      cmd: this.global.DocAddressSave
    };
    let option: DocAddressSaveInput = {
      id: this.selectedAdd?.id ? this.selectedAdd.id : 0,
      type: this.type,
      address: this.address
    }
    this.globalService.postData(qParam, option).subscribe((data: DocAddressSaveOutput) => {
      if (data && data.ok) {
        this.getAddresses();
      }
    });
  }

  deleteAddress(row: DocAddressOutput, event: Event) {
    event.stopPropagation();
    const qParam: DocAddressRemoveInput = {
      cmd: this.global.DocAddressRemove,
      id: row.id
    };
    this.globalService.getData(qParam).subscribe((data: DocAddressRemoveOutput) => {
      if (row.id == this.selectedAdd.id) {
        this.selectedAdd.id = 0;
        this.form.markAsDirty();
      }
      this.getAddresses()
    });
  }

  selectFile(event: any) {
    this.coverPhoto = event.name;
  }

}
